export const ComplianceGroupByFieldsToLabel = {
  equip_area: 'Area',
  risk_category: 'Risk Category',
}
